import cx from 'classnames';
import { useFieldIfAvailable } from "../../../core/useFieldIfAvailable";
import { Box, FormGroup, Input, Label, Text } from 'tombac';
import { SharedLimitWarning } from "./limitEditorElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function KmLimitEditor(_ref) {
  let {
    className,
    defaultLimit = null,
    isSharedLimit = false,
    isSharedWithOther = false,
    label,
    limit = null,
    onChange,
    schema
  } = _ref;
  const [field, meta, helpers] = useFieldIfAvailable(schema.name);
  if (field) {
    limit = field.value ?? null;
    onChange = helpers.setValue;
  }
  const handleChange = event => {
    let newLimit = null;
    if (event.target.value.trim() !== '') {
      newLimit = Number(event.target.value);
      newLimit = Number.isNaN(newLimit) ? limit : Math.abs(Math.floor(newLimit));
    }
    if (onChange) {
      onChange(newLimit);
    }
  };
  const placeholder = defaultLimit !== null ? String(defaultLimit) : isSharedLimit ? schema?.required ? '' : 'Use product limit' : 'Unlimited';
  const error = meta?.touched && meta?.error;
  return /*#__PURE__*/_jsx(FormGroup, {
    className: cx('KmLimitEditor', className),
    error: error,
    label: /*#__PURE__*/_jsxs(Label, {
      htmlFor: `input-${schema?.name}`,
      variant: error ? 'danger' : undefined,
      children: [label, schema?.required && /*#__PURE__*/_jsx(Text, {
        $display: "inline",
        as: "span",
        altFont: true,
        variant: "danger",
        children: "*"
      })]
    }),
    $width: "100%",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "KmLimitEditor",
    "data-sentry-source-file": "KmLimitEditor.tsx",
    children: schema.customizable ? /*#__PURE__*/_jsxs(Box, {
      $alignItems: "center",
      $display: "flex",
      children: [/*#__PURE__*/_jsx(Input, {
        $flex: "auto",
        append: "km",
        disabled: isSharedWithOther,
        id: `input-${schema?.name}`,
        invalid: Boolean(error),
        name: field?.name,
        onBlur: field?.onBlur,
        onChange: handleChange,
        placeholder: placeholder,
        type: "text",
        value: limit === null ? '' : limit.toString()
      }), isSharedWithOther && /*#__PURE__*/_jsx(SharedLimitWarning, {})]
    }) : /*#__PURE__*/_jsx("div", {
      className: "LimitEditor__value",
      children: limit !== null ? `${limit} km'` : placeholder
    })
  });
}